var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c('v-main',[_c('nav-bar',{on:{"refresh-view":function($event){_vm.routerViewKey++}}}),_c('snackbar',{ref:"global-snackbar"}),_c('router-view',{key:_vm.routerViewKey}),_c('theme-selector',{on:{"use-dark-theme":_vm.setDarkTheme}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }